export default __webpack_public_path__ + "static/media/AboutUsPage.5f097300.jpeg";